import React, { useState } from "react";

import ActionLogger from "action-logger";
import PDPImageryFeaturedPhotoReview from "./pdp-imagery-featured-photo-review";
import PDPImageryThumbControl from "./pdp-imagery-thumb-control";
import ProductImage from "../shared/product-image";
import { getProductImageAltText, ProductImageSize } from "../../../helpers/product-image-helpers";
import { productImagesPropType, productPropType } from "../../propTypes/product-prop-type";
import PropTypes from "prop-types";
import { FetchPriority } from "rtr-constants";

// @TODO: Add accessibility attributes similar to NarrowPDPImagery (i.e.role, aria-controls, aria-selected, etc.)
function PDPImageryThumbnails(props) {
  const [displayedThumbIndex, setDisplayedThumbIndex] = useState(0);

  const handleClickThumbControl = direction => {
    const { filteredImages = {} } = props;
    let newThumbIndex;
    const numThumbs = Object.keys(filteredImages).length;

    if (direction === "next") {
      newThumbIndex = Math.min(numThumbs - getPageSize(), displayedThumbIndex + 1);
    } else if (direction === "prev") {
      newThumbIndex = Math.max(0, displayedThumbIndex - 1);
    }

    setDisplayedThumbIndex(newThumbIndex);

    ActionLogger.logAction({
      action: "click_altimages_arrow",
      objectType: "node",
    });
  };

  const isSmall = () => {
    return props.isProductDrawer;
  };

  const getPageSize = () => {
    return isSmall() ? 2 : 3;
  };

  const getImageStyle = orientation => {
    const { filteredImages = {} } = props;
    const index = Object.keys(filteredImages).indexOf(orientation);
    const visible = index >= displayedThumbIndex && index < displayedThumbIndex + getPageSize();

    return { display: visible ? "block" : "none" };
  };

  const arrowClassName = (i, numThumbs) => {
    if (numThumbs < 3) {
      return "inactive";
    }
    // return an empty string rather than undefined as a classname
    return displayedThumbIndex === i ? "inactive" : "";
  };

  const { filteredImages = {}, product } = props;
  const numThumbs = Object.keys(filteredImages).length;
  const thumbViewportClassName = "thumb-viewport" + (isSmall() ? " thumb-viewport--small" : "");

  return (
    <div className="thumbnails">
      <PDPImageryThumbControl
        className={arrowClassName(0, numThumbs)}
        direction="prev"
        displayedThumbIndex={displayedThumbIndex}
        onClick={handleClickThumbControl}
      />
      <div className={thumbViewportClassName}>
        <div className="product-thumbnails">
          {Object.entries(filteredImages).map(([orientation, imageGroup]) => {
            return (
              <button
                className="product-thumbnail"
                key={"product-thumbnail-" + orientation}
                style={getImageStyle(orientation)}
                onClick={() => props.onClickThumbnail(orientation)}>
                <ProductImage
                  altText={getProductImageAltText(product?.displayName, product?.designer?.displayName)}
                  imageGroup={imageGroup}
                  imageSize={ProductImageSize.x183}
                  fetchPriority={FetchPriority.LOW}
                />
              </button>
            );
          })}
        </div>
      </div>
      <PDPImageryThumbControl
        className={arrowClassName(numThumbs - getPageSize(), numThumbs)}
        direction="next"
        displayedThumbIndex={displayedThumbIndex}
        onClick={handleClickThumbControl}
      />
      <PDPImageryFeaturedPhotoReview
        isProductDrawer={props.isProductDrawer}
        reviews={props.reviews}
        reviewsCoverPhotos={props.reviewsCoverPhotos}
      />
    </div>
  );
}

PDPImageryThumbnails.propTypes = {
  filteredImages: productImagesPropType,
  isProductDrawer: PropTypes.bool,
  onClickThumbnail: PropTypes.func,
  product: productPropType,
  reviews: PropTypes.shape({
    summary: PropTypes.object,
  }),
  reviewsCoverPhotos: PropTypes.array,
};

export default PDPImageryThumbnails;
